<template>
  <div class="gp-main-body-content">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "IntegrationLayout",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions("integration", {}),
    onTabChangeHandler() {}
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .gfLoader {
    background-color: rgba(#000, 0.5) !important;
  }
}
</style>
